import { Vector2 } from "three";
import { Vector3 } from "three";
import { Vector4 } from "three";
import { Color } from "three";
import { Quaternion } from "three";
export class CoreType {
  static isNumber(value) {
    return typeof value == "number";
  }
  static isVector(value) {
    return value instanceof Vector2 || value instanceof Vector3 || value instanceof Vector4;
  }
  static isColor(value) {
    return value instanceof Color;
  }
  static isQuaternion(value) {
    return value instanceof Quaternion;
  }
  static isString(value) {
    return typeof value == "string";
  }
  static isBoolean(value) {
    return value === true || value === false;
  }
  static isNaN(value) {
    return isNaN(value);
  }
  static isArray(value) {
    return Array.isArray(value);
  }
  static isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
  }
}
export function isBooleanTrue(value) {
  return value;
}
export function ensureString(value) {
  return value;
}
